const EXEMPT_PREFIXES = [
  '/logout',
  '/upgrade',
  '/payment-due',
  '/settings/plan',
  '/settings/billing',
  '/account',
  '/updates',
];

// Billing and account routes stay reachable for a store that never finished
// setup, so a seller stuck in the setup wizard can still pay or reach support.
export function isStoreSetupExemptPath(pathname) {
  return EXEMPT_PREFIXES.some(prefix => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

const MCP_CONSENT_PATH = '/oauth/authorize';

const AI_PAGE_PATH = /^\/pages\/[a-f0-9]{24}\/customize$/;

function isAiPagePath(pathname, search) {
  return AI_PAGE_PATH.test(pathname) && new URLSearchParams(search).get('ai') === '1';
}

// A seller who signed up to build one page with AI wants that page back after
// setup, so the redirect carries it along.
export function getStoreSetupPath({ pathname, search }) {
  const params = new URLSearchParams({ dashboard_create_store: 'true' });
  if (isAiPagePath(pathname, search)) params.set('next', `${pathname}?ai=1`);
  return `/seller/start?${params.toString()}`;
}

// A new account made to connect Claude or ChatGPT sets up its store first, then
// returns to the consent screen with the client's OAuth request intact.
export function getStoreSetupNext(search) {
  const next = new URLSearchParams(search).get('next') || '';
  const [pathname, query = ''] = next.split('?');
  if (pathname === MCP_CONSENT_PATH && query) return next;
  return isAiPagePath(pathname, `?${query}`) ? `${pathname}?ai=1` : null;
}

// The consent screen sits outside the /dashboard router, so reaching it takes a page load.
export function navigateFromDashboard(path, navigate) {
  if (path.startsWith(`${MCP_CONSENT_PATH}?`)) window.location.assign(path);
  else navigate(path);
}
